/**
 * A function that does nothing.
 */
export function noop(): void
export function noop(): undefined
export function noop() {}
